<template>
    <div class="mt-2">
        <h6 style="font-weight: bold">Label</h6>

        <b-row v-for="(item, index) in shipmentInfo.documents" v-bind:key="index">
            <b-col>
                <a
                    v-if="item.type === 'Label'"
                    :href="item.storageLink"
                    style="text-decoration: underline;"
                    target="_blank"
                    >{{ item.type }}
                </a>
            </b-col>
        </b-row>

        <div v-if="shipmentInfo.documents.some((element) => element.type != 'Label')">
            <h6 style="font-weight: bold" class="mt-2">{{ $t('history.label.Documents') }}</h6>

            <b-row v-for="(item, index) in shipmentInfo.documents" v-bind:key="index">
                <b-col>
                    <a
                        v-if="!item.type.includes('Label')"
                        :href="item.storageLink"
                        style="text-decoration: underline;"
                        target="_blank"
                        >{{ item.fileName ? item.fileName : item.type }}
                    </a>
                    <b-form-checkbox
                        v-if="!item.type.includes('Label')"
                        class="float-left"
                        size="sm"
                        @change="selectDocument(item)"
                        :checked="documentsToDelete.includes(item)"
                        :disabled="item.type.includes('Invoice' || 'SystemInvoice')"
                    ></b-form-checkbox>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX } from '@/store/constants';

export default {
    components: {},

    props: {
        shipmentInfo: { type: Object, required: true }
    },

    data() {
        return {
            documentsToDelete: []
        };
    },

    methods: {
        selectDocument(document) {
            if (!this.documentsToDelete.includes(document)) {
                this.documentsToDelete.push(document);
            } else {
                const index = this.documentsToDelete.indexOf(document);
                this.documentsToDelete.splice(index, 1);
            }
        },
        async deleteDocuments() {
            const request = {
                Documents: this.documentsToDelete
            };

            const response = await this.$store.dispatch(
                HISTORY_PREFIX + ACTIONS.HISTORY.DELETE_DOCUMENTS,
                request
            );

            this.shipmentInfo.documents = this.shipmentInfo.documents.filter(
                (el) => !this.documentsToDelete.includes(el)
            );

            this.documentsToDelete = [];
        }
    }
};
</script>

<style></style>
